export function trimTrailingChar(value, char) {
  const source = String(value ?? "");
  if (!char) return source;

  let end = source.length;
  while (end > 0 && source[end - 1] === char) {
    end -= 1;
  }
  return source.slice(0, end);
}

export function trimTrailingSlashes(value) {
  return trimTrailingChar(value, "/");
}

export function trimWrappingDoubleQuotes(value) {
  const source = String(value ?? "");
  if (source.length >= 2 && source[0] === '"' && source[source.length - 1] === '"') {
    return source.slice(1, -1);
  }
  return source;
}

function trimChar(value, char) {
  const source = String(value ?? "");
  if (!char) return source;

  let start = 0;
  let end = source.length;
  while (start < end && source[start] === char) start += 1;
  while (end > start && source[end - 1] === char) end -= 1;
  return source.slice(start, end);
}

function isAsciiDigit(code) {
  return code >= 48 && code <= 57;
}

function isAsciiLetter(code) {
  return (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
}

function isLetterLike(ch) {
  return ch.toLocaleLowerCase() !== ch.toLocaleUpperCase();
}

function isSafeFilenamePartChar(ch) {
  if (ch === "_" || ch === "-") return true;

  const code = ch.charCodeAt(0);
  return isAsciiDigit(code) || isAsciiLetter(code) || isLetterLike(ch);
}

export function safeFilenamePart(value, maxLength = 60) {
  const source = String(value || "").trim();
  if (!source) return "";

  let out = "";
  let previousWasUnderscore = false;

  for (const ch of source.normalize("NFKD")) {
    const next = isSafeFilenamePartChar(ch) ? ch : "_";
    if (next === "_") {
      if (out && !previousWasUnderscore) {
        out += "_";
      }
      previousWasUnderscore = true;
      continue;
    }

    out += next;
    previousWasUnderscore = false;
  }

  return trimChar(out, "_").slice(0, maxLength);
}
